// Native product forms own adding, errors and section refreshes. This only selects a variant.
class AcuraCartCollection extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onSlideClick);
    this.track = this.querySelector('.acura-cart-collection__products');
    this.track?.addEventListener('scroll', this.updateControls);
    this.resizeObserver = new ResizeObserver(this.updateControls);
    if (this.track) this.resizeObserver.observe(this.track);
    this.updateControls();
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.onVariantChange);
    this.removeEventListener('click', this.onSlideClick);
    this.track?.removeEventListener('scroll', this.updateControls);
    this.resizeObserver?.disconnect();
  }
  updateControls = () => {
    if (!this.track) return;
    const previous = this.querySelector('[data-cart-slide="previous"]');
    const next = this.querySelector('[data-cart-slide="next"]');
    if (previous) previous.disabled = this.track.scrollLeft <= 1;
    if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
  };
  onSlideClick = (event) => {
    const button = event.target.closest('[data-cart-slide]');
    if (!button || !this.track) return;
    const card = this.track.querySelector('.acura-cart-pick');
    const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0) : this.track.clientWidth;
    this.track.scrollBy({left: step * (button.dataset.cartSlide === 'next' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  onVariantChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-cart-pick-variant]')) return;
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    if (!option || !form) return;
    form.querySelector('input[name="id"]').value = option.value;
    form.querySelector('input[name="quantity"]').value = option.dataset.quantity || '1';
    form.closest('product-form-component').dataset.quantityDefault = option.dataset.quantity || '1';
    select.closest('.acura-cart-pick').querySelector('.acura-cart-pick__price').textContent = option.dataset.price;
    const card = select.closest('.acura-cart-pick');
    const compare = card.querySelector('[data-sale-compare]');
    const badge = card.querySelector('[data-sale-badge]');
    if (compare) compare.textContent = option.dataset.compare || '';
    if (badge) badge.textContent = `${option.dataset.discount || 0}% off`;
  };
}
if (!customElements.get('acura-cart-collection')) customElements.define('acura-cart-collection', AcuraCartCollection);
